import { Popover } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from '../../base/dialog/actions';
import { USER_FUNCTIONS } from '../../user/constant';
import { checkFunctionHaveCode, getFunctions } from '../../user/functions';
import CallSIPDialog from './add-people-dialog/web/CallSIPDialog';
import ListenSIPDialog from './add-people-dialog/web/ListenSIPDialog';
import CallSipButton from './CallSipButton.web';
import './styles.css';
import { closeOverflowMenuIfOpen } from '../../toolbox/actions.web';
function SipsMenu({ onClose }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const callVMPtoHNTH = () => {
        onClose();
        setTimeout(() => {
            dispatch(closeOverflowMenuIfOpen());
        }, 50);
        setTimeout(() => {
            dispatch(openDialog(CallSIPDialog));
        }, 300);
    };
    const callHNTHtoVMP = () => {
        onClose();
        setTimeout(() => {
            dispatch(closeOverflowMenuIfOpen());
        }, 50);
        setTimeout(() => {
            dispatch(openDialog(ListenSIPDialog));
        }, 300);
    };
    return (React.createElement("div", { className: "menu-popup overflow call-sip" },
        React.createElement("div", { className: 'options-menu-popup call-sip-options' },
            React.createElement("span", { id: 'vmp2sip', className: 'option-menu-popup', onClick: callVMPtoHNTH }, t('addPeople.vmp2sip')),
            React.createElement("span", { id: 'sip2vmp', className: 'option-menu-popup', onClick: callHNTHtoVMP }, t('addPeople.sip2vmp')))));
}
function CallSipMenuPopup({ afterClick }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const functions = useSelector(getFunctions);
    const open = Boolean(anchorEl);
    const onClose = () => {
        if (afterClick)
            afterClick();
        setAnchorEl(null);
    };
    const togglePopup = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    if (!checkFunctionHaveCode(functions, USER_FUNCTIONS.SIP_CONNECTION)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "call-sip-options", onClick: togglePopup },
            React.createElement(CallSipButton, { key: 'sipcall', showLabel: true, isShowTooltip: false, handleClick: () => { } }),
            React.createElement("span", { className: 'button-custom-hnth' },
                React.createElement("svg", { width: "8", height: "14", viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M7.61158 6.00895C7.55182 5.94628 7.49206 5.8836 7.40243 5.82093L2.23343 0.399553C1.72549 -0.133184 0.918766 -0.133184 0.41083 0.399553C-0.0971071 0.93229 -0.097107 1.7784 0.41083 2.31114L4.86274 6.98041L0.380952 11.681C-0.126985 12.2138 -0.126985 13.0599 0.380952 13.5926C0.619981 13.8433 0.948647 14 1.30719 14C1.63585 14 1.96452 13.8746 2.23343 13.5926L7.40243 8.17124C7.49206 8.10856 7.55182 8.04589 7.61158 7.98321C7.88048 7.70117 8 7.35646 8 7.01175C8 6.6357 7.88048 6.29099 7.61158 6.00895Z", fill: "white" })))),
        React.createElement(Popover, { id: "call-sip-pop", open: open, anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } },
            React.createElement(SipsMenu, { onClose: onClose }))));
}
export default CallSipMenuPopup;
